import a from "../../Assets/About/a.png";
import b from "../../Assets/About/b.png";
import c from "../../Assets/About/c.png";
import ai from "../../Assets/About/ai.png";
import android from "../../Assets/About/android.png";
import web3 from "../../Assets/About/web3.png";
const Images = [
    {
      id: 1,
      src: a,
      alt: "Image 1",
      title: "Background",
      border:"primary",
      description:
        "Originating from a rural area with minimal tech,yet with a passion for creating numerous things",
    },
    {
      id: 2,
      src: c,
      alt: "Image 2 ",
      title: "Education",
      border:"secondary",
      description:
        "I can now genuinely identify myself as a front-end developer thanks to my education and support",
    },
    {
      id: 3,
      src: b,
      alt: "Image 3",
      title: "Interests",
      border:"success",
      description: 
        "My two interests have come together perfectly in software development and ICT Infrastructure            ",
    },
    {
      id: 4,
      src: android,
      alt: "Image 4",
      title: "Programming laungages",
      border:"danger",
      description:
        "I am fluent in classics like :PHP, Javascript, Wordpress,Flutter, React JS.                              ",
    },
    {
      id: 5,
      src: web3,
      alt: "Image 5",
      title: "Next-Gen Developer",
      border:"warning",
      description:
        "Whenever possible, I also apply my passion for developing products with Flutter, PHP and react           ",
    },
    {
      id: 6,
      src: ai,
      alt: "Image 6",
      title: "AI and Robotings",
      border:"info",
      description:
        "I also create gadgets with the Arduino platform, which just needs basic programming skills.              ",
    },
    {
      id: 6,
      src: ai,
      alt: "Image 6",
      title: "AI and Robotings",
      border:"dark",
      description:
        "I also create gadgets with the Arduino platform, which just needs basic programming skills.               ",
    },
    {
      id: 6,
      src: ai,
      alt: "Image 6",
      title: "AI and Robotings",
      border:"light",
      description:
        "I also create gadgets with the Arduino platform, which just needs basic programming skills.                ",
    },
  ];
  
  export default Images;